import {
  Component,
  DeviceShadowDTO,
  TelemetryHistoryEnrichedDTO,
} from '@eppendorf/vnls-device-service-utils';

export function findShadowCompByTelemetryId(
  components: DeviceShadowDTO['components'],
  telemetryId: string,
) {
  return components?.find((item) => item.id === telemetryId);
}

export function findTelemById(
  telemetry: TelemetryHistoryEnrichedDTO[],
  telemetryId: string,
) {
  return telemetry?.find((item) => item.telemetryId === telemetryId);
}

export const hasThresholdValue = (value?: number | null): boolean =>
  value !== null && value !== undefined;

export function snapshotHasThresholds(shadowComponent?: Component): boolean {
  if (shadowComponent === undefined) {
    return false;
  }

  const thresholds = [
    shadowComponent.alertThreshold?.high,
    shadowComponent.alertThreshold?.low,
    shadowComponent.warnThreshold?.high,
    shadowComponent.warnThreshold?.low,
  ];

  return thresholds.some(hasThresholdValue) || !!shadowComponent.alertingEnabled;
}

export function createOfflineTelemetryPlaceholder(
  subject: string,
  name?: string,
): TelemetryHistoryEnrichedDTO {
  return {
    telemetryId: subject,
    name,
    value: undefined,
    unit: undefined,
    status: undefined,
    sentAt: undefined,
  } as unknown as TelemetryHistoryEnrichedDTO;
}
